import { useCallback } from 'react';
import { useFormikContext } from 'formik';

export type UseFocusFirstInvalidFieldParams = {
  orderedFieldNames: string[];
};

export const useFocusFirstInvalidField = <FormikValues extends Record<string, any>>({
  orderedFieldNames = [],
}: UseFocusFirstInvalidFieldParams) => {
  const { validateForm, setFieldTouched } = useFormikContext<FormikValues>();

  const focusFirstInvalidField = useCallback(async () => {
    const errors = await validateForm();
    const fieldErrors = !Array.isArray(orderedFieldNames)
      ? Object.keys(errors)
      : orderedFieldNames?.filter((name) => errors?.[name]);
    const firstField = fieldErrors?.[0];

    if (!firstField) return;

    const el = document.querySelector(`[name="${firstField}"]`);
    if (el && 'focus' in el) {
      el?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
      (el as HTMLElement)?.focus?.();
    }
    setFieldTouched(firstField, true, true);
  }, [setFieldTouched, validateForm, orderedFieldNames]);

  return {
    focusFirstInvalidField,
  };
};
